import {
    Box,
    Card,
    CardContent,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    Skeleton,
} from "@mui/material";

const CardSkeleton = ({ isModal }) => {
    return (
        <Grid item xs={12} sm={6} lg={isModal ? 6 : 3}>
            <Card
                sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "1.75rem",
                    border: "1px solid #d1d9e0",
                    minWidth: '48vh'
                }}
            >
                <CardContent
                    sx={{
                        p: 3,
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Skeleton
                        variant="text"
                        height={48}
                        width="100%"
                        sx={{ mx: "auto", mb: 1 }}
                    />

                    <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                        <Skeleton variant="rounded" width={120} height={28} />
                    </Box>

                    <Skeleton
                        variant="text"
                        height={28}
                        width="60%"
                        sx={{ mx: "auto", mb: 2 }}
                    />

                    <List dense sx={{ mb: 3, flexGrow: 1 }}>
                        {[1, 2, 3, 4].map((item) => (
                            <ListItem key={item} disableGutters>
                                <ListItemIcon sx={{ minWidth: 32 }}>
                                    <Skeleton variant="circular" width={20} height={20} />
                                </ListItemIcon>
                                <Skeleton variant="text" width="100%" height={22} />
                            </ListItem>
                        ))}
                    </List>

                    <Skeleton
                        variant="rounded"
                        height={48}
                        sx={{ borderRadius: "0.85rem" }}
                    />
                </CardContent>
            </Card>
        </Grid>
    );
};

export default CardSkeleton;
